import { OUTGOINGCALL_ERRORS } from "../../../common/constants/agentModule/outgoingcallConstants";
import { OUTGOING_URLS } from "../../apiConfig";
import apiClient from "../../apiInstance";

export const getPendingOutgoingCall = async (outboundCallWithAgent, status) => {
    try {
      const response = await apiClient.post(OUTGOING_URLS.GET_PENDING_OUTGOINGCALL, {
        outboundCallWithAgent, status
      });
      return response.data;
    } catch (error) {
      console.error(OUTGOINGCALL_ERRORS.FETCH_PENDING_OUTGOINGCALL_ERROR, error);
      throw error;
    }
  };

  export const addOngoingCall = async (addCalldetails) => {
    try {
      const response = await apiClient.post(OUTGOING_URLS.ADD_ONGOING_CALL, {
        addCalldetails
      });
      return response.data;
    } catch (error) {
      console.error(OUTGOINGCALL_ERRORS.ADD_ONGOING_CALL_ERROR, error);
      throw error;
    }
  };

    export const completeOngpingCall = async (status, id) => {
    try {
      const response = await apiClient.post(OUTGOING_URLS.COMPLETE_ONGPING_CALL, {
        status, id
      });
      return response.data;
    } catch (error) {
      console.error(OUTGOINGCALL_ERRORS.ADD_ONGOING_CALL_ERROR, error);
      throw error;
    }
  };